<template>
<div class="chapter">
<div class="inner_page">
<div class="book" title="Bonjour, Y’all"><div class="frontmatter"><div class="recto"><h1 class="title"><a id="index"></a>Bonjour, Y’all</h1><h2 class="subtitle">Heidi’s Fusion
              Cooking on the South Carolina Coast</h2><h3 class="author"><span class="uppercase">Heidi Vukov &amp; Sara
                Sobota</span></h3><h4><span class="uppercase">Photographs by Scott Smallin except as noted otherwise.</span></h4><img alt="Gibbs Smith Logo" src="Images/image00077.jpeg"/></div><div style="page-break-after:always"></div><div class="verso"><p class="versotitle">Bonjour, Y’all</p><p class="versotitle">Heidi’s Fusion Cooking on the
            South Carolina Coast</p><p>Digital Edition 1.0</p><p class="copyright">Text © 2015 Heidi
            Vukov &amp; Sara Sobota</p><p>Photographs © 2015 Scott Smallin except as noted
            otherwise.</p><p>All rights reserved. No part of this book may be reproduced by any
            means whatsoever without written permission from the publisher, except brief portions
            quoted for purpose of review.</p><p class="nobreak">Gibbs Smith</p><p class="nobreak">P.O. Box 667</p><p>Layton, Utah 84041</p><p class="nobreak">Orders:
            1.800.835.4993</p><p>www.gibbs-smith.com</p><p>ISBN:
        978-1-4236-3995-4</p></div></div><div class="frontmatter"><div style="page-break-after:always"></div><div class="dedication" title="Dedication"><p>This book is dedicated to my husband, Gary, and our children, Matt,
            Bryan, Alex, and Ben, for their understanding that we did not have traditional weekends
            and holidays like most families, knowing that those times were about serving others
            first. Although the days before Thanksgiving and Christmas were always the busiest days
            in the restaurant, we, as a family, were still able to pull off an enjoyable meal to
            share together and make wonderful memories.—HV </p><p>To my husband, Chris, for enduring
            the hours I spent huddled over the computer mumbling about crab, rye bread, and
            pastries; for his love of food; and for his support of my writing. Also to our boys,
            Bryce, Alex, and Aidan, who became quite fond of the frequent trips to “Heidi’s,” where
            they always enjoyed a special treat.—SS </p></div></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0001.vue?daed6a9a